// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_53-0";
export var eligibilityCardNotEligible = "_53-1";